import React, { useCallback, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { styled } from '@mui/material/styles'
import { Link, Box } from '@mui/material'
import { BasicCard, FlexRow } from './components'
import Text from '@/components/Text'
import Badge from '@/components/Badge'
import { AuthContext } from '@/layout/Auth'
import { CheckCircleFilled, RightLined } from '@/icon'
import { primary } from '@/constant'
import vf_placeholder from '@/asset/img/vf_placeholder.webp'

const PIC = styled('img')(() => ({
  position: 'absolute',
  right: '0',
  bottom: '0',
  //   width: "15%",
  transformOrigin: 'bottom',
  transform: 'scale(0.65)',
}))

const CardWrapper = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
}))

const Verification = () => {
  const navigate = useNavigate()
  const {
    authInfo: { verified },
  } = useContext(AuthContext)

  const toVerfify = useCallback(() => {
    navigate('/console/personal')
  }, [navigate])

  return (
    <CardWrapper sx={{}}>
      <BasicCard
        sx={{
          flex: 1,
          backgroundImage:
            'linear-gradient(90deg, rgba(255,255,255,1) 40%, rgba(195,248,199,0.5998993347338936) 100%)',
        }}
      >
        <Text>实名认证情况</Text>
        <FlexRow sx={{ alignItems: 'center', gap: '24px' }}>
          <Badge
            type={verified ? 'success' : 'warning'}
            shape={'rounded'}
            bordered='true'
            sx={{ fontSize: '12px' }}
          >
            <CheckCircleFilled fill={primary} />
            {verified ? '已认证' : '未实名认证'}
          </Badge>
          {!verified && (
            <Link underline='none' sx={{ display: 'flex' }} onClick={toVerfify}>
              立即认证 <RightLined />
            </Link>
          )}
        </FlexRow>
      </BasicCard>
      <div style={{ position: 'relative' }}>
        <PIC src={vf_placeholder} loading='lazy' />
      </div>
    </CardWrapper>
  )
}

export default Verification
